import {Container} from "./styled";
import {Header, Table} from "./lib";

interface CreditProps {}

export const Credit: React.FC<CreditProps> = () => {
  return (
    <Container>
      <Header />
      <Table />
    </Container>
  );
};
